// Style & Icon Helper Functions
// Extracted from Dream Wedding Generator and Moodboard Matcher

// Wedding-themed style icons mapping
export const styleIcons = {
  'romantic': '💕',
  'elegant': '✨',
  'rustic': '🌿',
  'vintage': '🕰️',
  'modern': '💎',
  'bohemian': '🌸',
  'classic': '👑',
  'garden': '🌺',
  'beach': '🏖️',
  'outdoor': '🌳',
  'indoor': '🏛️',
  'floral': '🌹',
  'natural': '🍃',
  'luxurious': '💰',
  'minimalist': '⚪',
  'whimsical': '🦋',
  'dramatic': '🎭',
  'soft': '🤍',
  'bold': '🔥',
  'delicate': '🌼'
};

// Function to get style icon for a given style tag
export const getStyleIcon = (styleTag) => {
  const tag = styleTag.toLowerCase();
  return styleIcons[tag] || '✨';
};

// Color Magic categories for AI suggestions
export const categories = [
  { id: 'decor', name: 'Decor', icon: '🏺' },
  { id: 'flowers', name: 'Flowers', icon: '🌸' },
  { id: 'attire', name: 'Attire', icon: '👗' },
  { id: 'lighting', name: 'Lighting', icon: '💡' },
  { id: 'stationery', name: 'Stationery', icon: '📜' },
  { id: 'food', name: 'Food & Cake', icon: '🍰' }
];

// Helper function to safely parse arrays
export const parseArray = (field) => {
  if (!field) return [];
  
  if (Array.isArray(field)) {
    return field;
  }
  
  if (typeof field === 'string') {
    try {
      // Try to parse as JSON first
      const parsed = JSON.parse(field);
      return Array.isArray(parsed) ? parsed : [field];
    } catch {
      // If JSON parsing fails, split by comma
      return field.split(',').map(item => item.trim()).filter(item => item.length > 0);
    }
  }
  
  return [];
};
